import { Part } from '../service-case/model/part';
import { ValueUpdater } from '../valueUpdater';
import { PartV10 } from './v10/case/model/partV10';
import { PartV11 } from './v11/service-case/model/partV11';
export class PartTransformer {
    static transformList(inVersion, outVersion, payload) {
        const resultList = [];
        payload.forEach((part) => {
            resultList.push(this.transform(inVersion, outVersion, part));
        });
        return resultList;
    }
    static transform(inVersion, outVersion, payload) {
        const transformation = inVersion + '-to-' + outVersion;
        switch (transformation) {
            case '12-to-10':
                return this.transformFromV12ToV10(payload);
            case '12-to-11':
                return PartV11.constructFromPlainObject(payload);
            case '10-to-12':
                return this.transformFromV10ToV12(payload);
            case '11-to-12':
                return Part.constructFromPlainObject(payload);
            default:
                throw new Error('Unsupported transformation: ' + transformation);
        }
    }
    static transformFromV12ToV10(payload) {
        const part = Part.constructFromPlainObject(payload);
        const dealerNetPrice = part.getDealerNetPricePerPart()
            ? part.getQuantity() * part.getDealerNetPricePerPart()
            : undefined;
        const absoluteDiscount = dealerNetPrice && part.getDiscountPercentage()
            ? (dealerNetPrice * part.getDiscountPercentage()) / 100
            : undefined;
        const customerNetPrice = dealerNetPrice && absoluteDiscount ? dealerNetPrice - absoluteDiscount : undefined;
        const valueAddedTaxInPercent = customerNetPrice && part.getValueAddedTax() ? (part.getValueAddedTax() / customerNetPrice) * 100 : undefined;
        const partV10 = new PartV10(part.getMainGroup(), part.getSubgroup(), part.getItemNumber(), part.getDescription(), part.getQuantity(), part.getInvoiceTransparency(), part.getHasClearingFlag(), part.getCoding(), part.getComment(), absoluteDiscount, part.getIsLocal(), part.getHasRetentionRequirement(), part.getReasonForRetentionRequirement(), ValueUpdater.updateNonNullableNumberOrUnknown(undefined, part.getDealerNetPricePerPart()), ValueUpdater.updateNonNullableNumberOrUnknown(undefined, part.getBmwNetPricePerPart()), ValueUpdater.updateNonNullableNumberOrUnknown(undefined, part.getSplit()), ValueUpdater.updateNonNullableNumberOrUnknown(undefined, part.getSuffix()), valueAddedTaxInPercent, part.getVehicle());
        partV10.setPositionNumber(ValueUpdater.updateNonNullableNumberOrUnknown(partV10.getPositionNumber(), part.getPositionNumber()));
        partV10.setSelected(ValueUpdater.updateNonNullableField(partV10.isSelected(), part.getIsSelected()));
        return partV10;
    }
    static transformFromV10ToV12(payload) {
        const partV10 = PartV10.constructFromPlainObject(payload);
        const dealerNetPrice = partV10.getPrice() ? partV10.getQuantity() * partV10.getPrice() : undefined;
        const discountPercentage = dealerNetPrice && partV10.getAbsoluteDiscount()
            ? (partV10.getAbsoluteDiscount() / dealerNetPrice) * 100
            : undefined;
        const customerNetPrice = dealerNetPrice && partV10.getAbsoluteDiscount() ? dealerNetPrice - partV10.getAbsoluteDiscount() : undefined;
        const valueAddedTax = customerNetPrice && partV10.getValueAddedTaxInPercent()
            ? (customerNetPrice * partV10.getValueAddedTaxInPercent()) / 100
            : undefined;
        const customerGrossPrice = customerNetPrice && valueAddedTax ? customerNetPrice + valueAddedTax : customerNetPrice;
        const part = new Part(partV10.getMainGroup(), partV10.getSubgroup(), partV10.getItemNumber(), partV10.getDescription(), partV10.getQuantity());
        part.setBmwNetPricePerPart(ValueUpdater.updateNullableField(part.getBmwNetPricePerPart(), partV10.getRetailPrice()));
        part.setCoding(ValueUpdater.updateNonNullableString(part.getCoding(), partV10.getCoding()));
        part.setComment(ValueUpdater.updateNonNullableString(part.getComment(), partV10.getComment()));
        part.setDealerNetPricePerPart(ValueUpdater.updateNullableField(part.getDealerNetPricePerPart(), partV10.getPrice()));
        part.setDiscountPercentage(ValueUpdater.updateNonNullableNumber(part.getDiscountPercentage(), discountPercentage));
        part.setHasClearingFlag(ValueUpdater.updateNonNullableBoolean(part.getHasClearingFlag(), partV10.getClearingFlag()));
        part.setHasRetentionRequirement(ValueUpdater.updateNonNullableBoolean(part.getHasRetentionRequirement(), partV10.getHasRetentionRequirement()));
        part.setInvoiceTransparency(ValueUpdater.updateNonNullableString(part.getInvoiceTransparency(), partV10.getInvoiceTransparency()));
        part.setIsLocal(ValueUpdater.updateNonNullableBoolean(part.getIsLocal(), partV10.getIsLocal()));
        part.setIsSelected(ValueUpdater.updateNonNullableBoolean(part.getIsSelected(), partV10.isSelected()));
        part.setPositionNumber(ValueUpdater.updateNullableNumber(part.getPositionNumber(), partV10.getPositionNumber()));
        part.setReasonForRetentionRequirement(ValueUpdater.updateNonNullableString(part.getReasonForRetentionRequirement(), partV10.getReasonForRetentionRequirement()));
        part.setSplit(ValueUpdater.updateNullableField(part.getSplit(), partV10.getSplit()));
        part.setSuffix(ValueUpdater.updateNullableField(part.getSuffix(), partV10.getSuffix()));
        part.setTotalCustomerGrossPrice(ValueUpdater.updateNullableField(part.getTotalCustomerGrossPrice(), customerGrossPrice));
        part.setValueAddedTax(ValueUpdater.updateNullableField(part.getValueAddedTax(), valueAddedTax));
        part.setVehicle(ValueUpdater.updateNonNullableString(part.getVehicle(), partV10.getVehicle()));
        return part;
    }
}
//# sourceMappingURL=partTransformer.js.map